import * as z from 'zod';

export const skillSubCategoryFormSchema = z.object({
  Title: z.string().trim().min(1, { message: 'TITLE_REQUIRED' }),
});

export type SkillSubCategoryFormValues = z.infer<typeof skillSubCategoryFormSchema>;
